"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHooksFromUrl = exports.getHooksFromOptions = exports.executeHook = void 0;
var _brembo = _interopRequireDefault(require("brembo"));
var _batchPromises = _interopRequireDefault(require("batch-promises"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /*
 * MIT License
 *
 * Copyright (c) 2022 Massimo Candela <https://massimocandela.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var getDataStringHook = function getDataStringHook(hook) {
  var _hook$batch, _hook$fields;
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var axios = arguments.length > 2 ? arguments[2] : undefined;
  var batch = (_hook$batch = hook.batch) !== null && _hook$batch !== void 0 ? _hook$batch : false;
  var options = {
    url: hook.url,
    method: (hook.method || "get").toLowerCase(),
    reponseType: "json"
  };
  if (hook.headers) {
    options.headers = hook.headers;
  }
  if (hook !== null && hook !== void 0 && (_hook$fields = hook.fields) !== null && _hook$fields !== void 0 && _hook$fields.length) {
    setFields(options, hook);
  }
  if (options.method === "get") {
    return axios(options).then(function (data) {
      return data.data;
    });
  } else if (batch) {
    return axios(_objectSpread(_objectSpread({}, options), {}, {
      data: [data].flat()
    })).then(function (data) {
      return data.data;
    });
  } else {
    var out = [];
    return (0, _batchPromises["default"])(4, data, function (item) {
      return axios(_objectSpread(_objectSpread({}, options), {}, {
        data: item
      })).then(function (data) {
        return out.push(data.data);
      });
    }).then(function () {
      return out;
    });
  }
};
var setFields = function setFields(options, hook) {
  options.headers = options.headers || {};
  options.headers["X-Fields"] = hook.fields;
  options.url = _brembo["default"].build(options.url, {
    canonical: true,
    params: {
      fields: hook.fields.join(",")
    }
  });
};
var createHookItem = function createHookItem(optionItem, defaultMethod, defaultUrl, options) {
  switch (_typeof(optionItem)) {
    case "undefined":
      if (!defaultUrl) {
        console[console.warn ? "warn" : "log"]("The ".concat(defaultMethod, " operations will not work, there is no valid url or function for it."));
        return function () {
          return Promise.resolve([]);
        };
      } else {
        return _objectSpread(_objectSpread({
          method: defaultMethod,
          url: defaultUrl
        }, options), {}, {
          fields: options.fields || [],
          headers: options.headers || {}
        });
      }
    case "function":
      return function (data) {
        var res = optionItem(data);
        if (typeof res === "string") {
          return _objectSpread(_objectSpread({
            method: defaultMethod,
            url: res
          }, options), {}, {
            fields: options.fields || [],
            headers: options.headers || {}
          });
        } else {
          return Promise.resolve(res);
        }
      };
    case "object":
      return _objectSpread(_objectSpread({
        method: optionItem.method || defaultMethod,
        url: optionItem.url || defaultUrl
      }, options), {}, {
        fields: options.fields || [],
        headers: optionItem.headers || options.headers || {}
      });
    default:
      throw new Error("Invalid ".concat(defaultMethod, " configuration"));
  }
};
var getHooksFromOptions = exports.getHooksFromOptions = function getHooksFromOptions(options) {
  var defaultUrl = typeof options.retrieve === "function" ? null : options.retrieve.url;
  return [createHookItem(options.retrieve, "get", defaultUrl, options), createHookItem(options.insert, "post", defaultUrl, options), createHookItem(options.update, "put", defaultUrl, options), createHookItem(options["delete"], "delete", defaultUrl, options)];
};
var getHooksFromUrl = exports.getHooksFromUrl = function getHooksFromUrl(url) {
  return [{
    method: "get",
    url: url
  }, {
    method: "post",
    url: url
  }, {
    method: "put",
    url: url
  }, {
    method: "delete",
    url: url
  }];
};
var executeHook = exports.executeHook = function executeHook(type, hook, data, axios) {
  try {
    var hookType = _typeof(hook);
    switch (hookType) {
      case "object":
        return getDataStringHook(hook, data, axios);
      case "function":
        var res = hook(data);
        if (res.method && res.url && res.headers) {
          return getDataStringHook(res, data, axios);
        } else {
          return res;
        }
      default:
        return Promise.reject("The ".concat(type, " hook must be a URL or a function returning a promise"));
    }
  } catch (e) {
    return Promise.reject(e);
  }
};